import { useCallback } from "react";
import { refreshTokens } from "../../api/cognitoApi";
import { useAuth } from "./useAuth";

export type FetchParams = {
  url: string;
  options?: RequestInit;
};

export const useFetchWithToken = () => {
  const { tokens, setTokens, logout } = useAuth();

  const fetchWithToken = useCallback(
    async (params: FetchParams): Promise<Response> => {
      let { url, options = {} } = params;
      const defaultOptions = {
        headers: {
          Authorization: `Bearer ${tokens.idToken}`,
          "Content-Type": "application/json",
        },
      };

      options = {
        ...defaultOptions,
        ...options,
      };

      let response;
      try {
        response = await fetch(url, options);
      } catch (error) {
        console.error("Fetch failed", error);
      }

      if (!response || response.status === 401) {
        // Token expired, try refreshing the token
        try {
          const newTokens = await refreshTokens(tokens.refreshToken);
          setTokens(newTokens);
          (options.headers as Record<string, string>)["Authorization"] =
            `Bearer ${newTokens.idToken}`;
          response = await fetch(url, options);
        } catch (error) {
          console.error("Unable to refresh tokens, logging out..", error);
          logout();
          throw error;
        }
      }

      return response;
    },
    [tokens.idToken, tokens.refreshToken, setTokens, logout],
  );

  return { fetchWithToken };
};
